import * as React from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

// const useStyles = makeStyles((theme) => ({
//   maxWidth: 2000,
//   maxheight: 300,

//   close: {
//     padding: theme.spacing(0.5),
//   },
// }));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function SnackBarComponent(props) {
  // const classes = useStyles();
  const { opensb, handleClose, content, severity } = props;

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      open={opensb}
      autoHideDuration={3000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
        {content}
      </Alert>
    </Snackbar>
    // <Snackbar
    //   open={opensb}
    //   message={content}
    //   autoHideDuration={1000}
    //   anchorOrigin={{
    //     vertical: "bottom",
    //     horizontal: "center",
    //   }}
    // >
    //   <Alert
    //     severity={severity}
    //     action={
    //       <IconButton
    //         aria-label="close"
    //         color="inherit"
    //         size="small"
    //         onClick={handleClose}
    //       >
    //         <CloseIcon fontSize="inherit" />
    //       </IconButton>
    //     }
    //   >
    //     {content}
    //   </Alert>
    // </Snackbar>
  );
}
